export default {
    contained: {
        name: "Contained",
        url: "nwcg_lines_perimeter_line/contained",
    },
}
